
import { Component, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { CvatTasks } from '../../../models/tasks_cvat';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Table } from 'primeng/table';
import { CvatProjectsService } from '../../../services/cvat-projects.service';
import { MainHeaderComponent } from '../../shared/main-header/main-header.component';
import { DataTableComponent } from '../../shared/data-table/data-table.component';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { UsersService } from '../../../users/users.service';
import { CvatProjects } from '../../../models/cvat-projects';
import { TableCustomFilterComponent } from "../../shared/table-custom-filter/table-custom-filter.component";

@Component({
  selector: 'app-cvat-projects',
  standalone: true,
  imports: [MainHeaderComponent, DataTableComponent, MatButtonModule, CommonModule, MatFormFieldModule, RouterLink, TableCustomFilterComponent],
  templateUrl: './cvat-projects.component.html',
  styleUrl: './cvat-projects.component.scss'
})
export class CvatProjectsComponent {
  projects$!: Observable<CvatProjects>
  selected!: CvatProjects[];
  selectedProjects: CvatTasks[] = [];
  canDelete: boolean = false;
  selectedItems: any[] = [];


  columns: any[] = [
    { field: 'id', header: 'Id', filter: true, orderby: true },
    { field: 'name', header: 'Nombre', filter: true, orderby: true },
    { field: 'tasks.count', header: 'Cantidad de tareas', filter: true, orderby: true },
  ]

  @ViewChild('dt') table!: Table;
  constructor(private _snackBar: MatSnackBar, private router: Router, public cvatService: CvatProjectsService, private route: ActivatedRoute, private userService: UsersService) { }

  ngOnInit(): void {
    this.cvatService.loadProjects();
    this.userService.loadUsersStore()
    this.checkUserRoles()
  }
  
    checkUserRoles(): void {
      this.userService.getCurrentUserUid$().subscribe((uid) => {
      if (uid) {
        this.userService.users$.subscribe((users) => {
          const currentUser = users.find((user) => user.uid === uid);
          if (currentUser) {
            this.canDelete = currentUser.roles?.admin || currentUser.roles?.superadmin || false;
            console.log('Roles cargados:', currentUser.roles, 'Can Delete:', this.canDelete);
          } else {
            console.warn('Usuario no encontrado en la lista de usuarios.');
            this.canDelete = false;
          }
        });
      } else {
        console.error('No se pudo obtener el UID del usuario autenticado.');
        this.canDelete = false;
      }
    });
  }

  onSelectionChange(event: any) {
    this.selectedProjects = event

  }

  onSeeDetails(event: any) {
    const selected = event;
     console.log('Selected project:', selected);
    if (selected?.id) {
      this.router.navigate(['/cvat', 'projects' , selected.id, 'tasks']);
    }
  }

  onRowSelect(event: any) {
    console.log('select', this.selectedProjects)
  }

  onDeleteItems(items: any) {
  if (!this.canDelete) {
    this._snackBar.open('No tienes permisos para eliminar este proyecto', 'Cerrar', { duration: 3000 });
    return;
  }
   console.log('ITEMS', items)
   console.log('ID DEL PROYECTO', items.id)
  if (window.confirm("Esto eliminará este proyecto y todas sus configuraciones")) {
    this.cvatService.deleteProject(items.id).subscribe({
  next: () => {
    this.selectedProjects = [];
    this._snackBar.open(`Project ${items.id} eliminado.`, 'ok', { duration: 3000 });
    this.cvatService.loadProjects();
  },
  error: (err:any) => {
    console.error('Error al eliminar el proyecto:', err);
    }
    })
  }
}

  deleteClient(project: CvatProjects[]) {
    //  this._snackBar.open('Eliminando...', 'ok');
    // if (window.confirm("Esto eliminará este cliente y todas sus configuraciones")) {
    //     clients.map(clients => {
    //     this.clientsService.deleteClients(clients.client_id).subscribe(() => {
    //       this.selectedProducts = []
    //       console.log('cliente delete')
    //       this._snackBar.open(`Cliente ${clients.client_id} eliminado.`, 'ok');
    //       this.clientsService.loadClientsStore()
    //     })
    //   })
    //   } 
  }


}
